/**
 * @obj the watched Object
 * @properties the watched properties
 * #    add listener: Store#add_${property_name}_watcher
 * #    remove listener: Store#remove_${property_name}_watcher
 */
export default (obj, properties) => {
    properties.forEach(({ key, defaultValue }) => {
        const privateName = `__${key}`
        const watcherName = `${key}Watchers`

        obj[privateName] = defaultValue
        obj[watcherName] = []
        obj[`add_${key}_watcher`] = (key, watcher) => {
            obj[watcherName][key] = watcher
            watcher(obj[privateName])
        }
        obj[`remove_${key}_watcher`] = (key) => {
            delete obj[watcherName][key]
        }

        Object.defineProperty(obj, key, {
            set (value) {
                try {
                    obj[privateName] = value
                    const watchers = obj[watcherName]
                    Object.keys(watchers).forEach((key) => {
                        watchers[key](value)
                    })
                } catch (err) {
                    console.error(err)
                }
            },
            get () {
                return obj[privateName]
            }
        })
    })
    return obj
}
